import { render, staticRenderFns } from "./seeMessage.vue?vue&type=template&id=555f03c4&scoped=true&"
import script from "./seeMessage.vue?vue&type=script&lang=js&"
export * from "./seeMessage.vue?vue&type=script&lang=js&"
import style0 from "./seeMessage.vue?vue&type=style&index=0&id=555f03c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555f03c4",
  null
  
)

export default component.exports